import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

// Authentication
import LoginReducer from "./auth/login/reducer";
import AccountReducer from "./auth/register/reducer";
import ForgetPasswordReducer from "./auth/forgetpwd/reducer";
import UserListReducer from "./user/UserList/reducer";
import UserDetailsReducer from "./user/UserDetails/reducer";
import MealCategoryReducer from "./mealCategory/mealCategoryList/reducer";
import AdminProfile from "./auth/profile/reducer";

import ChangePassworReducer from "./auth/changepwd/reducer";
import DashboardReducer from "./Dashboard/reducer";

import TaxMasterReducer from "./TaxMaster/reducer";
import CustomerReducer from "./Customers/reducer";
import SupplierReducer from "./Supplier/reducer";
import VehicleReducer from "./VehicleMaster/reducer";
import SessionReducer from "./Session/reducer";
import TripsReducer from "./Trip/reducer";
import SalesInvoiceReducer from "./SalesInvoiceGST/reducer";
import InvoiceChargesReducer from "./InvoiceCharges/reducer";

const rootReducer = combineReducers({
  Layout: LayoutReducer,
  Login: LoginReducer,
  Account: AccountReducer,
  ForgetPassword: ForgetPasswordReducer,
  UserList: UserListReducer,
  UserDetails: UserDetailsReducer,
  MealCategory: MealCategoryReducer,
  Aprofile: AdminProfile,
  ChangePassword: ChangePassworReducer,
  Dashboard: DashboardReducer,
  TaxMaster: TaxMasterReducer,
  Customer: CustomerReducer,
  Supplier: SupplierReducer,
  Vehicle: VehicleReducer,
  Session: SessionReducer,
  Trip: TripsReducer,
  SalesInvoice: SalesInvoiceReducer,
  InvoiceCharges: InvoiceChargesReducer,
});

export default rootReducer;
